import { Button, CircularProgress } from "@mui/material";
import { buttonStyle, spinnerStyle } from "./styles";

export const SubmitButton = ({
  children,
  isProcessing,
  onClick,
  color = "primary",
  variant = "contained",
}: {
  children: React.ReactNode;
  isProcessing?: boolean;
  onClick: () => void;
  color?: "primary" | "secondary" | "error" | "warning" | "info" | "success";
  variant?: "contained" | "outlined" | "text";
}) => (
  <Button onClick={onClick} variant={variant} type="submit" disabled={isProcessing} sx={buttonStyle} color={color}>
    <>
      {isProcessing ? <CircularProgress size={18} color="inherit" sx={spinnerStyle} /> : null}
      {children}
    </>
  </Button>
);
